import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/ProjectFileLog";

export const GEOMETRY_PREFIX_URL = PREFIX_URL;

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const GetDirectoriesAndFiles = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetDirectoriesAndFiles`, options);

export const DownloadFile = (options) =>
  GENERATE_URL(`${PREFIX_URL}/DownloadFile`, options);

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const UploadFile = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UploadFile`, options);

export const CompressFile = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CompressFile`, options);

export const GetById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetById/:id`, options);

export const DeleteFile = (options) =>
  GENERATE_URL(`${PREFIX_URL}/DeleteFile`, options);

export const ActivateFileLog = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ActivateFileLog`, options);

export default {
  GetAll,
  Create,
  GetById,
  GetDirectoriesAndFiles,
  DownloadFile,
  UploadFile,
  CompressFile,
  DeleteFile,
  ActivateFileLog,
};
